import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {SalesAssociate} from '../types/SalesAssociate';

export const useGetSalesAssociates = (dealerCompanyID: number, enabled: boolean) => {
	const { data, isLoading } = useQuery({
		queryKey: ['sales-associates', dealerCompanyID],
		queryFn: async () => await apiClient.get('company/sales-associates', {
			params: {
				dealerCompanyID: dealerCompanyID
			}
		}) as SalesAssociate[],
		enabled: enabled
	});

	return {
		data: data || [],
		isLoading: isLoading
	};
};
